var _circle, _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 54,
    stroke: "#EE3D5D",
    strokeMiterlimit: 4.13357,
    strokeLinecap: "round",
    strokeDasharray: "30 16 10 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 10.4763C32.6496 10.4763 10.4766 32.6496 10.4766 60.0006C10.4766 87.3507 32.6493 109.523 60.0001 109.523C87.3509 109.523 109.524 87.3507 109.524 60.0006C109.524 32.6496 87.3507 10.4763 60.0001 10.4763Z",
    fill: "#FFEEF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4409_31011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7835 60.0004C92.7835 78.1069 78.1057 92.7842 59.9992 92.7842C41.8933 92.7842 27.2148 78.1069 27.2148 60.0004C27.2148 41.8939 41.8933 27.2161 59.9992 27.2161C78.1057 27.2161 92.7835 41.8939 92.7835 60.0004Z",
    fill: "url(#paint0_linear_4409_31011)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8352 44.4581C58.8352 43.8144 59.3571 43.2925 60.0008 43.2925C69.2284 43.2925 76.7087 50.7728 76.7087 60.0004C76.7087 69.2279 69.2284 76.7082 60.0008 76.7082C50.7733 76.7082 43.293 69.2279 43.293 60.0004C43.293 59.3566 43.8149 58.8347 44.4586 58.8347C45.1024 58.8347 45.6243 59.3566 45.6243 60.0004C45.6243 67.9403 52.0609 74.3769 60.0008 74.3769C67.9408 74.3769 74.3774 67.9403 74.3774 60.0004C74.3774 52.0604 67.9408 45.6238 60.0008 45.6238C59.3571 45.6238 58.8352 45.1019 58.8352 44.4581Z",
    fill: "#EE3D5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6488 44.8194C55.8782 45.4209 55.5766 46.0945 54.9751 46.324C54.7058 46.4267 54.4402 46.537 54.1786 46.6546C53.5914 46.9185 52.9014 46.6564 52.6375 46.0693C52.3736 45.4821 52.6356 44.7921 53.2228 44.5282C53.5254 44.3921 53.8327 44.2646 54.1442 44.1457C54.7457 43.9163 55.4194 44.2179 55.6488 44.8194ZM50.0859 47.778C50.5278 48.2462 50.5065 48.9839 50.0383 49.4258C49.8268 49.6254 49.6211 49.8312 49.4216 50.0427C48.9798 50.511 48.242 50.5325 47.7738 50.0907C47.3055 49.6489 47.284 48.9111 47.7258 48.4429C47.9563 48.1986 48.1938 47.961 48.438 47.7304C48.9062 47.2885 49.644 47.3098 50.0859 47.778ZM46.0729 52.6298C46.6599 52.894 46.9217 53.5841 46.6575 54.1712C46.5386 54.4353 46.4272 54.7034 46.3235 54.9754C46.0942 55.5769 45.4207 55.8787 44.8191 55.6494C44.2176 55.42 43.9158 54.7465 44.1451 54.1449C44.2651 53.8302 44.394 53.52 44.5315 53.2144C44.7957 52.6273 45.4858 52.3656 46.0729 52.6298Z",
    fill: "#EE3D5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5133 54.5133C54.9685 54.0581 55.7066 54.0581 56.1618 54.5133L60.0002 58.3517L63.8386 54.5133C64.2938 54.0581 65.0319 54.0581 65.4871 54.5133C65.9423 54.9685 65.9423 55.7066 65.4871 56.1618L61.6487 60.0002L65.4871 63.8386C65.9423 64.2938 65.9423 65.0319 65.4871 65.4871C65.0319 65.9423 64.2938 65.9423 63.8386 65.4871L60.0002 61.6487L56.1618 65.4871C55.7066 65.9423 54.9685 65.9423 54.5133 65.4871C54.0581 65.0319 54.0581 64.2938 54.5133 63.8386L58.3517 60.0002L54.5133 56.1618C54.0581 55.7066 54.0581 54.9685 54.5133 54.5133Z",
    fill: "#EE3D5D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4409_31011",
    x: 12.3558,
    y: 12.357,
    width: 95.2865,
    height: 95.2862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.42953
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4409_31011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4409_31011",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4409_31011",
    x1: 59.9992,
    y1: 27.2161,
    x2: 59.9992,
    y2: 92.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DEFF",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFeature);
export default __webpack_public_path__ + "static/media/deleteFeature.f3347b2b2dbdb74acd7a13ab7444c8cd.svg";
export { ForwardRef as ReactComponent };